module.exports = __webpack_public_path__ + "static/media/salad2.a65de1f5.png";